import PlpExtendedBanner from './PlpExtendedBanner';

export default PlpExtendedBanner;
